(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../StackRoute/StackRoute"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../StackRoute/StackRoute"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.StackRoute);
    global.useRoutes = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _StackRoute) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.routesByChildren = routesByChildren;
  _exports.useRoutes = useRoutes;

  function routesByChildren(children) {
    return _react.Children.toArray(children).map(function (child) {
      return child.type === _StackRoute.StackRoute ? child : null;
    }).filter(function (route) {
      return !!route;
    });
  }

  function useRoutes(children) {
    return (0, _react.useMemo)(function () {
      return routesByChildren(children);
    }, [children]);
  }
});